import { GENDER_CODE_IMS, GetImsIdentityResponse } from '../types/ims';
import { ImsToCiamGenderCodeMapping, RegistrationFlowFormValues } from '../types/registrationFlows';

export function mapImsIdentityToInitialFormValues(
  imsIdentity: GetImsIdentityResponse,
  defaultFormValues: RegistrationFlowFormValues
): RegistrationFlowFormValues {
  const dateOfBirth: string | undefined = imsIdentity.demographicsPerson?.dateOfBirth;
  const birthDate: Date | undefined = dateOfBirth ? new Date(dateOfBirth) : undefined;

  return {
    firstName: imsIdentity.namesPerson?.firstName ?? defaultFormValues.firstName,
    lastName: imsIdentity.namesPerson?.lastName ?? defaultFormValues.lastName,
    address: {
      city: imsIdentity.address?.city ?? defaultFormValues.address.city,
      street: imsIdentity.address?.street ?? defaultFormValues.address.street,
      houseNumber: imsIdentity.address?.houseNumber ?? defaultFormValues.address.houseNumber,
      box: imsIdentity.address?.houseNumberExtension ?? defaultFormValues.address.box,
      postalCode: imsIdentity.address?.postalCode ?? defaultFormValues.address.postalCode,
    },
    country: imsIdentity.address?.countryCode ?? defaultFormValues.country,
    gender:
      ImsToCiamGenderCodeMapping[
        imsIdentity.demographicsPerson?.genderCode ?? GENDER_CODE_IMS.UNKNOWN
      ] ?? defaultFormValues.gender,
    genderOther: imsIdentity.demographicsPerson?.genderCustom ?? defaultFormValues.genderOther,
    telephone: imsIdentity.contactpointsPhone?.phone ?? defaultFormValues.telephone,
    birthDateYear: birthDate ? `${birthDate.getFullYear()}` : defaultFormValues.birthDateYear,
    birthDateMonth: birthDate ? `${birthDate.getMonth() + 1}` : defaultFormValues.birthDateMonth,
    birthDateDay: birthDate ? `${birthDate.getDate()}` : defaultFormValues.birthDateDay,
    optins: defaultFormValues.optins,
  };
}
